<template>
  <div class="ag-payment-monthyear-editor" @keydown.enter="onEnter">
    <app-datepicker v-model="dateModel" format="MMMM yyyy" minimum-view="month" ref="datepicker"
                    class="ag-payment-monthyear-editor__datepicker"/>
    <div @click.stop="deleteValue" class="ag-payment-monthyear-editor__button ag-payment-monthyear-editor__button_delete">
      <app-icon name="TrashIcon" size="18px" class="ag-payment-monthyear-editor__button-icon"/>
    </div>
    <div @click.stop="save" class="ag-payment-monthyear-editor__button ag-payment-monthyear-editor__button_save">
      <app-icon name="SaveIcon" size="18px" class="ag-payment-monthyear-editor__button-icon"/>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';

  export default Vue.extend({
    name: "MonthYearEditor",
    data() {
      return {
        value: null,
        valueBody: null,
      }
    },
    computed: {
      dateModel: {
        get() {
          return this.value;
        },
        set(v) {
          this.value = v !== null ? this.$moment(v).toDate() : null;
        }
      }
    },
    methods: {
      afterGuiAttached() {
        this.value = JSON.parse(JSON.stringify(this.params.value));
        this.valueBody = null;
        this.$nextTick(() => {
          this.$refs.datepicker.focus();
        });
      },
      isPopup() {
        return false;
      },
      getValue() {
        return this.valueBody;
      },
      save() {
        let value = this.value;
        this.valueBody = {
          value: value
        };
        this.params.stopEditing();
      },
      onEnter(e){
        e.preventDefault();
        e.stopPropagation();
        this.save();
      },
      deleteValue(){
        this.dateModel = null;
        this.$refs.datepicker.focus();
      }
    },
    beforeDestroy() {
      this.$refs.datepicker.close();
    }
  })
</script>

<style lang="scss">
  .ag-payment-monthyear-editor {
    height: 100%;
    display: flex;

    &__datepicker {
      .vdp-datepicker {
        height: 100%;

        & > div:first-child {
          height: 100%;

          input {
            border: none;
            width: 100%;
            height: 100%;
            padding: 5px 0 5px 10px !important;
            font: inherit;
            font-size: 12px;

            &:focus {
              padding: 5px 0 5px 10px !important;
              border-bottom: none !important;
            }
          }
        }
      }
    }

    &__button {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 5px;

      &_save {
        .ag-payment-monthyear-editor__button-icon {
          &:hover {
            cursor: pointer;
            color: rgba(var(--app-success), 1);
          }
        }
      }

      &_delete {
        .ag-payment-monthyear-editor__button-icon {
          &:hover {
            cursor: pointer;
            color: rgba(var(--app-danger), 1);
          }
        }
      }

      &-calculated {
        border: 1px solid;
        border-radius: 50%;
        height: 18px;
        width: 18px;
        font-size: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
        cursor: pointer;
        padding: 4px;

        &_active,
        &:hover {
          background: rgba(var(--app-success), 1);
          border-color: rgba(var(--app-success), 1);
          color: #fff;
        }
      }
    }
  }

</style>
